module.exports = __webpack_public_path__ + "icon-128-visualisation-bar.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-bar.png
// module id = 626
// module chunks = 11